import nonJsonApiClient from '../util/nonJsonApiClient'

export default nonJsonApiClient(process.env.REACT_APP_MIKASA_URI)
